import { Component } from '@angular/core';
import { CalioFlatButtonComponent } from '@calio-lib/calio-button/calio-flat-button/calio-flat-button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  imports: [TranslateModule, CalioFlatButtonComponent]
})
export class PageNotFoundComponent {
}
